import { useDispatch, useSelector } from "react-redux";
// import type { AppDispatch, RootState } from '../state/store';

export const useGDDispatch = () => useDispatch();
export const useGDSelector = useSelector;